

<div
        class="relative inline-flex items-center w-full"
        [class.opacity-50]="disabled()"
        [class.cursor-not-allowed]="disabled()"
        tabindex="0"
>
    <!-- Varsinainen syötekenttä -->
    @if (formController()){

        <!-- Angular form controller -->
        <input
                #inputElement
                class="border border-gray-400 flex-1 w-full"
                [ngClass]="inputPaddingStyle()"
                [formControl]="formController()"
                [placeholder]="placeholderText()"
                [type]="type()"
                (change)="onValueChange()"
        />

    } @else {

        <!-- NgModel -->
        <input
                #inputElement
                class="border border-gray-400 flex-1 w-full"
                [ngClass]="inputPaddingStyle()"
                [placeholder]="placeholderText()"
                [disabled]="disabled()"
                [(ngModel)]="linkedValue"
                [type]="type()"
                (change)="onValueChange()"
        />

    }


    <!-- Yksikkö kentän ulkopuolella -->
    @if (unit()) {
        <span class="ml-2 text-gray-500">
      {{ unit() }}
    </span>
    }

    <!-- Optionaalinen custom content, esim. ikoni -->
    @if (customContent) {
        <span class="absolute right-9 top-2">
      <ng-container [ngTemplateOutlet]="customContent()"></ng-container>
    </span>
    }
</div>
